/*Site Info Banner Widget*/
/* eslint-disable */
(function ($) {
  //Data service for the widget
  function widgetDataService() {
    this.getWidgetData = function (
      servicePath,
      widgetModuleItemID,
      successCallback,
      errorCallback
    ) {
      $.ajax({
        type: 'POST',
        url: servicePath,
        data: "{'widgetModuleItemID':" + widgetModuleItemID + '}',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: successCallback,
        error: errorCallback,
      });
    };
  }

  //Global variable for the widget function
  var widgetModuleItemID = 0;
  var widgetData = null;
  var widgetContainer = null;
  var eventNameContentContainer = null;
  var eventDatesContentContainer = null;
  var numberOfDays;
  var previouslyViewedDate = true;
  var customConnector = null;
  var eventLength = null;
  var afterMessage = '';
  var siteInfoBannerLoaded = function () {};
  var countdownTextPrefix = '{#days} Days';

  //Constructor for the wiget
  $.fn.SiteInfoBanner = function (options) {
    var opts = $.extend({}, $.fn.SiteInfoBanner.defaultOptions, options);

    widgetContainer = this;
    widgetModuleItemID = opts.currentWidgetModuleItemID;

    eventNameContentContainer = widgetContainer.find('#eventName');
    eventDatesContentContainer = $('.countdown-timer-text strong');
    previouslyViewedDate = opts.previouslyViewedDate;
    countdownTextPrefix = opts.countdownTextPrefix;

    var widgetDataAdapter = new widgetDataService();

    widgetDataAdapter.getWidgetData(
      opts.scriptPath,
      opts.currentWidgetModuleItemID,
      getWidgetDataSuccess,
      getWidgetDataError
    );

    customConnector = opts.customConnector;
    siteInfoBannerLoaded = opts.siteInfoBannerLoaded;
  };

  //Default options for the constructor to be merged with send constructor data
  $.fn.SiteInfoBanner.defaultOptions = {
    scriptPath: 'services/eventsservice.asmx',
    currentWidgetModuleItemID: 0,
    previouslyViewedDate: true,
    customConnector: null,
    siteInfoBannerLoaded: function () {

      var daysContainer = $('#countdown-timer-days');
      var hoursContainer = $('#countdown-timer-hours');
      var minContainer = $('#countdown-timer-minutes');
      var secContainer = $('#countdown-timer-seconds');

      function formatNumberDate(eventDate) {
        const [eventDateMonth, eventDateDay] = eventDate.split(' ');
        let shortMonth = eventDateMonth === 'September' ? eventDateMonth.slice(0, 4) : eventDateMonth.slice(0, 3);
        const isSameMonth = eventDateDay === undefined;
        const day = isSameMonth ? shortMonth : eventDateDay;

        return `${
          !isSameMonth ? shortMonth + '.' : ''
        } ${day}`;
      }

      function formatEventDateString() {
        const countdownDates = $('.countdown-timer-text strong');
        const eventDateString = widgetData.DateString.split(',')[0];
        const [eventDateStart, eventDateEnd] = eventDateString
          .split('-')
          .map((date) => date.trim());
        const singleDate = eventDateEnd === undefined;

        const eventDateFormatted = singleDate
          ? formatNumberDate(eventDateStart)
          : `${formatNumberDate(
              eventDateStart
            )} <span> - </span>${formatNumberDate(eventDateEnd)}`;
        countdownDates.html(eventDateFormatted);
      }

      if (widgetData.NumberOfDays >= 1) {
        var daysUntilEvent = widgetData.NumberOfDays;

        function formatDate(date) {
          var monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ];
          var day = date.getDate();
          var monthIndex = date.getMonth();
          var year = date.getFullYear();
          return day + ' ' + monthNames[monthIndex] + ' ' + year;
        }

        // add number of days left to current date
        var currentDate = new Date();
        var numberOfDaysToAdd = daysUntilEvent;
        currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd);

        var coundownToThisDate = formatDate(currentDate);

        // Set the date we're counting down to
        var countDownDate = new Date(coundownToThisDate).getTime();
        formatEventDateString();
        // Update the count down every 1 second
        var x = setInterval(function () {
          // Get todays date and time
          var now = new Date().getTime();

          // Find the distance between now an the count down date
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Display the result in the element
          // console.log( days + "d " + hours + "h "
          // + minutes + "m " + seconds + "s " );

          daysContainer.text(days);
          hoursContainer.text(hours);
          minContainer.text(minutes);
          secContainer.text(seconds);

          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(x);
            console.log('EXPIRED');
          }
        }, 1000);
      } else {
        // if 0 days left
        // formatEventDateString();
        daysContainer.text('0');
        hoursContainer.text('0');
        minContainer.text('0');
        secContainer.text('0');
      }
    },
  };

  //service call worked
  var getWidgetDataSuccess = function (data) {
    widgetData = data.d;
    initialize();
  };

  //service call has failed
  var getWidgetDataError = function (data) {
    console.log(
      'Site Info Banner failed to load',
      '\n' + 'Status: ' + data.status + ' ' + data.statusText,
      '\n' + data.responseText
    );
  };

  //set up the ui
  function initialize() {
    if (!widgetData.Enabled) {
      return;
    }

    if (widgetData.ShowAfterEventMessage == true) {
      afterMessage = widgetData.AfterEventMessage;
    }
    //new properties
    //widgetData.EventLength (in days, an event that has the same start date and end date would result in a 0)
    //widgetData.DuringEventMessage
    //widgetData.AfterEventMessage
    var m = 0;
    eventLength = widgetData.EventLength;
    numberOfDays = widgetData.NumberOfDays;
    if (numberOfDays <= 0) {
      m = numberOfDays + eventLength;
    }

    var i = numberOfDays + 50;
    if (numberOfDays > 0) {
      var until = 'until ';

      if (customConnector != null) {
        until = customConnector;
      }

      if (widgetData.LoadedFromCountdowns) {
        until = '';
      }

      eventDatesContentContainer.text(widgetData.DateString);
      if (previouslyViewedDate == false) {
        setInterval(function () {
          if (i >= numberOfDays) {
            if (i == 1) {
              eventNameContentContainer.html(
                '<span class="countdownDays">' +
                  i +
                  ' <span class="dayWord">day</span></span> ' +
                  until +
                  widgetData.EventName
              );
              i--;
            } else {
              eventNameContentContainer.html(
                '<span class="countdownDays">' +
                  i +
                  ' <span class="dayWord">days</span></span> ' +
                  until +
                  widgetData.EventName
              );
              i--;
            }
          }
        }, 50);
      } else {
        if (numberOfDays == 1) {
          eventNameContentContainer.html(
            '<span class="countdownDays">' +
              numberOfDays +
              ' <span class="dayWord">day</span></span> ' +
              until +
              widgetData.EventName
          );
        } else {
          eventNameContentContainer.html(
            '<span class="countdownDays">' +
              numberOfDays +
              ' <span class="dayWord">days</span></span> ' +
              until +
              widgetData.EventName
          );
        }
      }
    } else if (m < 0) {
      if (widgetData.EventName != null) {
        eventDatesContentContainer.text(widgetData.EventName);
      }
      eventNameContentContainer.html(
        '<span class="countdownDays">' + afterMessage + '</span>'
      );
      if (afterMessage == '') {
        $('#widgetBanner').addClass('noThankYouMessage'); // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
        $('body').addClass('siteInfoBannerWidgetNoThankYouMessage'); // preferred method allows a class to be added even when the widget is not added to the banner
      }
      $('#widgetBanner').addClass('datePast'); // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
      $('body').addClass('siteInfoBannerWidgetDateIsPast'); // preferred method allows a class to be added even when the widget is not added to the banner
    } else {
      $('#siteInfoBannerWidget').css('display', 'block');
      eventDatesContentContainer.text(widgetData.DateString);
      eventNameContentContainer.css('display', 'none');
      $('#widgetBanner').addClass('eventHappening'); // this is NOT the preferred method (preferred method is on following line) - this is to support clients that rely on this class
      $('body').addClass('siteInfoBannerWidgetEventHappening'); // preferred method allows a class to be added even when the widget is not added to the banner
    }

    siteInfoBannerLoaded(widgetData);
    var infoBannerCountdownContent = $('.countdownDays').html();
    var infoBannerDatesContent = $('#eventDates').html();
    if (infoBannerCountdownContent == '' && infoBannerDatesContent == '') {
      $('body').addClass('siteInfoBannerOff');
    } else {
      $('body').addClass('siteInfoBannerOn');
    }
    widgetContainer.show();
  }
})(jQuery);
